'use client';

export function useTracking() {
  function trackEmailClick({
    email,
    pageName,
  }: {
    email: string;
    pageName: string;
  }) {
    window.dataLayer = window.dataLayer || [];
    const pageUri = window.location.href;

    window.dataLayer.push({
      event: 'email_click',
      page_uri: pageUri,
      page_name: pageName,
      ec_email: email,
    });
  }

  function trackWhatsappClick({
    phoneNumber,
    pageName,
  }: {
    phoneNumber: string;
    pageName: string;
  }) {
    window.dataLayer = window.dataLayer || [];
    const pageUri = window.location.href;

    window.dataLayer.push({
      event: 'whatsapp_click',
      page_uri: pageUri,
      page_name: pageName,
      ec_phone: phoneNumber,
    });
  }

  /**
   * Track phone link clicks with consent checking
   */
  function trackPhoneClick({
    phoneNumber,
    pageName,
  }: {
    phoneNumber: string;
    pageName: string;
  }) {
    window.dataLayer = window.dataLayer || [];
    const pageUri = window.location.href;

    window.dataLayer.push({
      event: 'phone_click',
      page_uri: pageUri,
      page_name: pageName,
      ec_phone: phoneNumber,
    });
  }

  /**
   * Track form submissions with consent checking
   */
  function trackLeadFormSubmit({
    pageName,
    pageUri,
  }: {
    pageName: string;
    pageUri?: string;
  }) {
    window.dataLayer = window.dataLayer || [];

    const uri = pageUri ?? window.location.href;

    window.dataLayer.push({
      event: 'lead_form_submit',
      page_uri: uri,
      page_name: pageName,
      form_type: 'lead_inquiry',
      form_id: 'lead-inquiry-form',
    });
  }

  return {
    trackPhoneClick,
    trackEmailClick,
    trackWhatsappClick,
    trackLeadFormSubmit,
  };
}
